import React, { useRef } from 'react';
import { Button } from 'reactstrap';
import html2pdf from 'html2pdf.js';
import { formatNumber } from 'redux/action/api';
import { headerColors } from 'redux/action/api';

const AppropriationLawWebView = ({ data = [], year, newFilter, newFilterHead }) => {
  const contentRef = useRef();

  const calculateSum = (node, field) => {
    if (!node.children || node.children.length === 0) return node[field] || 0;
    let sum = node[field] || 0;
    for (const child of node.children) sum += calculateSum(child, field);
    return sum;
  };

  const calculatePersonnel = (node) => calculateSum(node, 'personnel');
  const calculateOverhead = (node) => calculateSum(node, 'overhead');
  const calculateCapital = (node) => calculateSum(node, 'capital');
  const calculateRec = (node) => calculateSum(node, 'total_rec');
  const calculateTotal = (node) => calculateSum(node, 'total_exp');

  const handleDownload = () => {
    html2pdf().set({
      margin: 10,
      filename: `appropriation-law-${year}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
      pagebreak: { mode: ['css', 'legacy'] }
    }).from(contentRef.current).save();
  };

  const cellStyle = { border: '1px solid #000', padding: '5px', fontSize: '11px' };
  const headerStyle = { ...cellStyle, backgroundColor: 'orange', fontWeight: 'bold', textAlign: 'center' };

  const renderItems = (item, index) => {
    const isTitle = ['0000000000000000000', '1000000000000000000', '2000000000000000000', '3000000000000000000', '5000000000000000000', '7000000000000000000', '8000000000000000000'].includes(item.code);
    
    return (
      <React.Fragment key={`group_${index}`}>
        {!newFilterHead(item) && (
          <tr style={{ fontWeight: 'bold' }}>
            <td style={{ ...cellStyle, backgroundColor: headerColors[item.parentHeads?.length] }}>{isTitle ? '' : item.code?.replace(/0+$/, '')}</td>
            <td style={{ ...cellStyle, backgroundColor: headerColors[item.parentHeads?.length], textDecoration: isTitle ? 'underline' : 'none' }}>{isTitle ? 'Total Expenditure' : item.description}</td>
            <td style={{ ...cellStyle, textAlign: 'right', backgroundColor: headerColors[item.parentHeads?.length] }}>{isNaN(calculatePersonnel(item)) ? '---' : formatNumber(calculatePersonnel(item))}</td>
            <td style={{ ...cellStyle, textAlign: 'right', backgroundColor: headerColors[item.parentHeads?.length] }}>{isNaN(calculateOverhead(item)) ? '---' : formatNumber(calculateOverhead(item))}</td>
            <td style={{ ...cellStyle, textAlign: 'right', backgroundColor: headerColors[item.parentHeads?.length] }}>{isNaN(calculateRec(item)) ? '---' : formatNumber(calculateRec(item))}</td>
            <td style={{ ...cellStyle, textAlign: 'right', backgroundColor: headerColors[item.parentHeads?.length] }}>{isNaN(calculateCapital(item)) ? '---' : formatNumber(calculateCapital(item))}</td>
            <td style={{ ...cellStyle, textAlign: 'right', backgroundColor: headerColors[item.parentHeads?.length] }}>{isNaN(calculateTotal(item)) ? '---' : formatNumber(calculateTotal(item))}</td>
          </tr>
        )}
        {item.children?.map((child, idx) => {
          if (child.children?.length) return renderItems(child, idx);
          if (newFilter(child)) return null;
          return (
            <tr key={`row_${index}_${idx}`}>
              <td style={cellStyle}>{child.code}</td>
              <td style={cellStyle}>{child.description}</td>
              <td style={{ ...cellStyle, textAlign: 'right' }}>{isNaN(child.personnel) ? '---' : formatNumber(child.personnel)}</td>
              <td style={{ ...cellStyle, textAlign: 'right' }}>{isNaN(child.overhead) ? '---' : formatNumber(child.overhead)}</td>
              <td style={{ ...cellStyle, textAlign: 'right' }}>{isNaN(child.total_rec) ? '---' : formatNumber(child.total_rec)}</td>
              <td style={{ ...cellStyle, textAlign: 'right' }}>{isNaN(child.capital) ? '---' : formatNumber(child.capital)}</td>
              <td style={{ ...cellStyle, textAlign: 'right' }}>{isNaN(child.total_exp) ? '---' : formatNumber(child.total_exp)}</td>
            </tr>
          );
        })}
      </React.Fragment>
    );
  };

  return (
    <div style={{ backgroundColor: '#f5f5f5', padding: '20px', minHeight: '100vh' }}>
      <div style={{ position: 'sticky', top: '10px', zIndex: 1000, textAlign: 'right', marginBottom: '10px' }}>
        <Button color="primary" onClick={handleDownload}>Download PDF</Button>
      </div>
      
      <div ref={contentRef} style={{ backgroundColor: 'white', padding: '20px', margin: '0 auto', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
        <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>APPROPRIATION LAW {year}</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={headerStyle}>Code</th>
              <th style={headerStyle}>Description</th>
              <th style={headerStyle}>Personnel</th>
              <th style={headerStyle}>Overhead</th>
              <th style={headerStyle}>Total Recurrent</th>
              <th style={headerStyle}>Capital</th>
              <th style={headerStyle}>Total Expenditure</th>
            </tr>
          </thead>
          <tbody>{data?.map((item, i) => renderItems(item, i))}</tbody>
        </table>
      </div>
    </div>
  );
};

export default AppropriationLawWebView;
